module.exports = __webpack_public_path__ + "static/crossroad_krk-cdac5b9fa499625166b192f48a777718.webp";